module.exports = __webpack_public_path__ + "static/img/vip-fei-1.602f73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-fei-1.png
// module id = GgzT
// module chunks = 1